export type NotificationFormType = {
  formUtils: {
    activeStep: number;
    totalSteps: number;
    review: boolean;
    InputsSteps: string[][];
  };
  person: string;
  patientName: string;
  notificationTypeId: object;
  notificationCategoryId: {
    inputValue?: string;
    inputLabel?: string;
  };
  notificationIncidentId: object;
  notificationOptionId?: object;
  notificationTechnicalComplaintId?: {
    inputValue?: string;
    inputLabel?: string;
  };
  descriptionIncident: string;
  descriptionActionAfterIncident: string;
  questions: NotificationCategoriesQuestionsAnswersProps[];
  AttachedFiles?: File[];
  recaptchaToken?: string;
};

type NotificationCategoriesQuestionsAnswersProps = {
  inputValue: string;
  inputLabel: string;
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers: {
    answerId: number;
    answerDescription: string;
  }[];
};

export const InputsStep1IncidentNotification = [
  'person',
  'personType',
  'notificationRefersToId',
  'patientIdentification',
  'patientName',
  'genderId',
  'patientBirthDate',
  'patientBirthDateIsValid',
];

export const InputsStep2IncidentNotification = [
  'notificationIntubationDateId',
  'notificationMoreInfoInput',
  'unitId',
  'notificationIntubationDateIdIsValid',
];

export const InputsStep3IncidentNotification = [
  'notificationTypeId',
  'notificationCategoryId',
  'notificationIncidentId',
  'notificationOptionId',
  'notificationTechnicalComplaintId',
  'questions',
  'descriptionIncident',
  'descriptionActionAfterIncident',
  'patientOrFamilyKnow',
  'thereWasNegativeDemonstration',
  'witnessSignalingLegalCompanySocialMediaByFamily',
  'whoWasNotified',
];

export const InputsStep4IncidentNotification = [
  'occupationId',
  'notifierName',
  'notifierEmail',
  'notifierUnitId',
];
export const InputsStep5IncidentNotification = ['responsabilityTerm'];

export const InputsStepsIncidentNotification = [
  InputsStep1IncidentNotification,
  InputsStep2IncidentNotification,
  InputsStep3IncidentNotification,
  InputsStep4IncidentNotification,
  InputsStep5IncidentNotification,
  // [], [], [], [], []
];

export const TitleStepsIncidentNotification = [
  'Identificação',
  'Quando e onde ocorreu?',
  'Como ocorreu este incidente',
  'Mecanismo de detecção',
];
